
declare var grecaptcha: any;


$("#contactform").one('submit', function(e) {
    
    e.preventDefault();
    var form = $(this)[0] as HTMLFormElement;

    var apiKey = $(this).attr('data-gapikey');

    grecaptcha.ready(function() {
        grecaptcha.execute(apiKey, { action: 'contact' }).then(function(token) {
            $('#RecaptchaToken').val(token);

            form.submit();
        });
    });


})